import Layout from '../components/Layout';


const featureImages = [
  {
    file: 'academic games .png',
    label: 'Academic Games: Speed Math & Alkebulan',
    desc: 'Speed Math boosts students\' math skills through fast-paced challenges, while Alkebulan is a Pan-African quiz game that celebrates African knowledge and culture. Both games make learning engaging and competitive.',
    link: '/alkebulan',
    linkLabel: 'Play Alkebulan',
  },
  {
    file: 'ai checks.png',
    label: 'AI Checks',
    desc: 'Leverage offline AI-powered checks to provide instant feedback on assignments and quizzes. The AI works without internet access, helping students identify mistakes early and learn more efficiently.'
  },
  {
    file: 'ai simplify.png',
    label: 'AI Simplify',
    desc: 'Complex topics are broken down into simple, easy-to-understand explanations using AI, ensuring every student can grasp challenging material at their own pace.'
  },
  {
    file: 'calculator and dictionary embeded.png',
    label: 'Calculator and Dictionary Embedded',
    desc: 'Built-in calculator and dictionary tools allow students to solve problems and look up definitions without leaving the learning environment, streamlining their workflow.'
  },
  {
    file: 'essay checks.png',
    label: 'Essay Checks',
    desc: 'Automated essay checks provide constructive feedback on writing, helping students improve grammar, structure, and clarity in their essays.'
  },
  {
    file: 'Essay Questions.png',
    label: 'Essay Questions',
    desc: 'A diverse set of essay questions encourages critical thinking and creativity, allowing students to express their understanding in depth.'
  },
  {
    file: 'learning page.png',
    label: 'Learning Page',
    desc: 'The central learning page organizes lessons, assignments, and resources in one place, making it easy for students to stay on track.'
  },
  {
    file: 'login page.png',
    label: 'Login Page',
    desc: 'A secure and user-friendly login page ensures that students can access their accounts safely and quickly.'
  },
  {
    file: 'personal notes.png',
    label: 'Personal Notes',
    desc: 'Students can take and organize personal notes within the platform, supporting active learning and better information retention.'
  },
  {
    file: 'progress reports.png',
    label: 'Progress Reports',
    desc: 'Detailed progress reports help students and parents track learning achievements and identify areas for improvement.'
  },
  {
    file: 'questions.png',
    label: 'Questions',
    desc: 'A robust question bank provides ample practice opportunities, helping students prepare thoroughly for exams and assessments. The questions are designed to boost retention and in-depth knowledge.'
  },
];

const Features = () => (
  <Layout>
    <section
      className="features-page"
      style={{
        background: 'linear-gradient(120deg, #f8fafc 0%, #e0e7ef 100%)',
        minHeight: '100vh',
        padding: '1rem 0',
      }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 1rem' }}>
        <h1 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, marginBottom: '0.5rem', color: '#1a237e' }}>Features</h1>
        <p style={{ textAlign: 'center', fontSize: '1.2rem', color: '#374151', marginBottom: '1.5rem' }}>
          Discover how Pascaline empowers students with innovative tools and a seamless learning experience.
        </p>
        <div
          className="features-list"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '2.5rem',
          }}
        >
          {featureImages.map((img) => (
            <div
              className="feature-item"
              key={img.file}
              style={{
                background: '#fff',
                borderRadius: '18px',
                boxShadow: '0 4px 24px rgba(30, 41, 59, 0.08)',
                padding: '2rem 1.5rem 1.5rem 1.5rem',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: 420,
                transition: 'transform 0.2s',
              }}
              onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-6px) scale(1.03)')}
              onMouseOut={e => (e.currentTarget.style.transform = 'none')}
            >
              <img
                src={"/images/" + img.file}
                alt={img.label}
                style={{
                  maxWidth: '320px',
                  width: '100%',
                  height: '220px',
                  borderRadius: '14px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                  marginBottom: '1.2rem',
                  background: '#f3f4f6',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <h2 style={{ fontSize: '1.35rem', fontWeight: 600, color: '#1a237e', margin: '0 0 0.7rem 0' }}>{img.label}</h2>
              <p style={{ color: '#374151', fontSize: '1.05rem', lineHeight: 1.6 }}>{img.desc}</p>
              {img.link && (
                <a
                  href={img.link}
                  style={{
                    marginTop: '1rem',
                    display: 'inline-block',
                    padding: '0.6rem 1.4rem',
                    background: 'linear-gradient(90deg, #1a237e 60%, #3949ab 100%)',
                    color: '#fff',
                    borderRadius: '8px',
                    fontWeight: 500,
                    fontSize: '1rem',
                    textDecoration: 'none',
                    boxShadow: '0 2px 8px rgba(30,41,59,0.10)',
                    transition: 'background 0.2s',
                  }}
                  onMouseOver={e => (e.currentTarget.style.background = 'linear-gradient(90deg, #3949ab 60%, #1a237e 100%)')}
                  onMouseOut={e => (e.currentTarget.style.background = 'linear-gradient(90deg, #1a237e 60%, #3949ab 100%)')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {img.linkLabel || 'Learn More'}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  </Layout>
);

export default Features;
